<template>
    <div class="bg-[#2E2F2F] border-[1px] border-[#383939] rounded-[13px] w-full pb-[10px]">
        <div class="text-[#C59014] text-[20px] font-bold text-center mt-[12px]">
            Тижневий цикл - Планування
        </div>

        <div class="flex mt-[10px] px-[10px]">
            <!-- MD-5 ПТ -->
            <div class="w-[14.28%] border-r-[1px] border-[#C59014] px-[7px]">
                <div :class="{ 'current-day-flag': shortDay == 'ПТ' }" class="rounded-[10px] h-full">
                    <div class="text-[#C59014] font-bold text-[18px] text-center">MD-5</div>
                    <div class="text-[#C59014] font-bold text-[14px] text-center">-пт-</div>
                    <div class="mt-[4px] flex flex-col items-center justify-center">
                        <div class="text-[12px] text-center">Направленість: <b class="text-[#C59014]">Техніко-тактична</b></div>
                        <div class="text-[12px] text-center">Навантаження: <b class="text-[#C59014]">Середнє</b></div>
                    </div>
                    <div class="text-[12px] text-center mt-[4px]">
                        Тренажерний зал — підтримання силових показників.<br>
                        Індивідуальна, групова техніка тактика
                    </div>
                </div>
            </div>

            <!-- MD-4 СБ -->
            <div class="w-[14.28%] border-r-[1px] border-[#C59014] px-[7px]">
                <div :class="{ 'current-day-flag': shortDay == 'СБ' }" class="rounded-[10px] h-full">
                    <div class="text-[#C59014] font-bold text-[18px] text-center">MD-4</div>
                    <div class="text-[#C59014] font-bold text-[14px] text-center">-сб-</div>
                    <div class="mt-[4px] flex flex-col items-center justify-center">
                        <div class="text-[12px] text-center">Направленість: <b class="text-[#C59014]">Швидкісно-силова</b></div>
                        <div class="text-[12px] text-center">Навантаження: <b class="text-[#C59014]">Велике</b></div>
                    </div>
                    <div class="text-[12px] text-center mt-[4px]">
                        Станції на вибухову силу — до або після тренування. Або швидкісно-силові станції на полі.<br>
                        Вправи в малих групах (удари, дуелі, єдиноборства, ігри)
                    </div>
                </div>
            </div>

            <!-- MD-3 НД -->
            <div class="w-[14.28%] border-r-[1px] border-[#C59014] px-[7px]">
                <div :class="{ 'current-day-flag': shortDay == 'НД' }" class="rounded-[10px] h-full">
                    <div class="text-[#C59014] font-bold text-[18px] text-center">MD-3</div>
                    <div class="text-[#C59014] font-bold text-[14px] text-center">-нд-</div>
                    <div class="mt-[4px] flex flex-col items-center justify-center">
                        <div class="text-[12px] text-center">Направленість: <b class="text-[#C59014]">Спеціальна витривалість</b></div>
                        <div class="text-[12px] text-center">Навантаження: <b class="text-[#C59014]">Велике</b></div>
                    </div>
                    <div class="text-[12px] text-center mt-[4px]">
                        Позиційні ігри<br>8х8, 9х9, 10х10
                    </div>
                </div>
            </div>

            <!-- MD-2 ПН -->
            <div class="w-[14.28%] border-r-[1px] border-[#C59014] px-[7px]">
                <div :class="{ 'current-day-flag': shortDay == 'ПН' }" class="rounded-[10px] h-full">
                    <div class="text-[#C59014] font-bold text-[18px] text-center">MD-2</div>
                    <div class="text-[#C59014] font-bold text-[14px] text-center">-пн-</div>
                    <div class="mt-[4px] flex flex-col items-center justify-center">
                        <div class="text-[12px] text-center">Направленість: <b class="text-[#C59014]">Техніко-тактична з елементами швидкості</b></div>
                        <div class="text-[12px] text-center">Навантаження: <b class="text-[#C59014]">Середнє</b></div>
                    </div>
                    <div class="text-[12px] text-center mt-[4px]">
                        Групова-командна тактика, 10х10 (модель гри).<br>
                        Стандартні положення (кутові, штрафні, аути — АТАКА)
                    </div>
                </div>
            </div>

            <!-- MD-1 ВТ -->
            <div class="w-[14.28%] border-r-[1px] border-[#C59014] px-[7px]">
                <div :class="{ 'current-day-flag': shortDay == 'ВТ' }" class="rounded-[10px] h-full">
                    <div class="text-[#C59014] font-bold text-[18px] text-center">MD-1</div>
                    <div class="text-[#C59014] font-bold text-[14px] text-center">-вт-</div>
                    <div class="mt-[4px] flex flex-col items-center justify-center">
                        <div class="text-[12px] text-center">Направленість: <b class="text-[#C59014]">Техніко-тактична</b></div>
                        <div class="text-[12px] text-center">Навантаження: <b class="text-[#C59014]">Середнє</b></div>
                    </div>
                    <div class="text-[12px] text-center mt-[4px]">
                        Групова-командна тактика, 10х10 (модель гри).<br>
                        Стандартні положення (АТАКА)
                    </div>
                </div>
            </div>

            <!-- Match Day СР -->
            <div class="w-[14.28%] border-r-[1px] border-[#C59014] px-[7px]">
                <div :class="{ 'current-day-flag': shortDay == 'СР' }" class="rounded-[10px] h-full">
                    <div class="text-[#C59014] font-bold text-[18px] text-center">Match-DAY</div>
                    <div class="text-[#C59014] font-bold text-[14px] text-center">-ср-</div>
                    <div class="font-bold text-center flex justify-center mt-[40px] text-[18px]">
                        ГРА
                    </div>
                </div>
            </div>

            <!-- Day-off ЧТ -->
            <div class="w-[14.28%] px-[7px]">
                <div :class="{ 'current-day-flag': shortDay == 'ЧТ' }" class="rounded-[10px] h-full">
                    <div class="text-[#C59014] font-bold text-[18px] text-center">DAY-off</div>
                    <div class="text-[#C59014] font-bold text-[14px] text-center">-чт-</div>
                    <div class="font-bold text-center flex justify-center mt-[40px] text-[18px]">
                        Вихідний
                    </div>
                </div>
            </div>
        </div>

        <div v-if="openFlag" class="flex mt-[10px] px-[10px]">
            <!-- MD-5 details -->
            <div class="w-[14.28%] border-r-[1px] text-[12px] text-center border-[#C59014] px-[7px]">
                <b class="text-[#C59014]">Технічний блок</b><br>
                <b>- АКЦЕНТ -</b><br>
                робота в малих групах, дотиків, обʼєм, безперервність — час проведений із мʼячем<br><br>

                <b class="text-[#C59014]">Ігрові вправи</b><br>
                Структурні, когнітивні — позиційні володіння в середніх групах, різноманітні квадрати.
                Акцент на володіння мʼячем при рівних складах або чисельній перевазі<br><br>

                <b class="text-[#C59014]">Оборона / атака</b><br>
                Відпрацювання оборони та атаки в декілька темпів.
                В ігрових вправах 3х2, 6х4, 8х6 в різних ситуаціях<br><br>

                <b class="text-[#C59014]">ЗАГРАВАННЯ</b><br>
                Футбол 2/3 поля 70х60 м: 3 команди з <b>ДРУГИМ ТЕМПОМ</b> (для оборони-атаки) + флангова подача.<br>
                Футбол в двох зонах: з виходом від воріт або з середньої зони з перемиканням на оборону в декілька темпів. Контроль темпу<br><br>

                <b class="text-[#C59014]">Індивідуальна / групова робота</b><br>
                Оборона — тематичні технічні вправи (прийоми-передачі, гра головою) + флангові завершення (удари на виконання)
            </div>

            <!-- MD-4 details -->
            <div class="w-[14.28%] border-r-[1px] border-[#C59014] px-[7px] text-center text-[12px]">
                <b class="text-[#C59014]">ІНТЕНСИВНІСТЬ</b><br>
                за рахунок організації процесу, правильно підібраних вправ та їх реалізації<br><br>

                <b class="text-[#C59014]">Технічний блок</b><br>
                Інтенсивні вибухові вправи (пассінг), групові взаємодії з мʼячем в малих групах.
                Або позиційні ігри в малих групах<br><br>

                <b class="text-[#C59014]">Робота в малих групах</b><br>
                Футбол в малих групах: 3х3+6, 2х2+4, 3х3+3 в одні ворота, 4х4+4.<br>
                Гра 1х1 (швидкі атаки, на час), 1х1 / 2х1 атаки в два темпи, 1х1 в позиціях.
                Тримання 1х1+4, 2х2+4, удари<br><br>

                <b class="text-[#C59014]">ЗАГРАВАННЯ</b><br>
                Футбол (акваріум — 4 команди), футбольний турнір на двох майданчиках, футбол 3 команди (на швидку зміну)
            </div>

            <!-- MD-3 details -->
            <div class="w-[14.28%] border-r-[1px] border-[#C59014] px-[7px] text-[12px] text-center">
                <b class="text-[#C59014]">ІНТЕНСИВНІСТЬ</b><br>
                за рахунок організації процесу та реалізації вправ<br><br>

                <b class="text-[#C59014]">Технічний блок</b><br>
                Інтенсивний, обʼємний пассінг в 2-ках, структурний в великих групах, квадрати<br><br>

                <b class="text-[#C59014]">Позиційні ігри</b><br>
                Володіння в середній зоні, вихід з першої зони (відпрацювання структури)<br><br>

                <b class="text-[#C59014]">Фази переходів</b><br>
                Переходи в атаку-оборону (реакція на втрату / заволодіння мʼячем).
                Вправи на просторі. Створення умов та контроль безперервності при виконанні ігрових вправ<br><br>

                <b class="text-[#C59014]">Двостороння гра із завданнями</b><br>
                Серія без стандартів (безперервність).<br>
                Серія з відпрацюванням стандартів при повному контакті
            </div>

            <!-- MD-2 details -->
            <div class="w-[14.28%] border-r-[1px] border-[#C59014] px-[7px] text-[12px] text-center">
                <b>Емоційні ігри, технічний блок, квадрати</b><br><br>

                <b class="text-[#C59014]">2 групи</b><br>
                Індивідуальні, групові, командні дії в атаці-обороні<br><br>

                <b class="text-[#C59014]">— КОМАНДНА ТАКТИКА —</b><br>
                Початок атак (10х0 або в чисельній перевазі) — вихід від воріт (схеми / варіанти) з переходом у швидку атаку з завершенням.
                Моделювання групового пресингу.<br>
                Початок атак в середній зоні — подолання високого блоку<br><br>

                <b class="text-[#C59014]">ЗАГРАВАННЯ ФУТБОЛ</b><br>
                в двох зонах з виходом від воріт або з середньої зони з перемиканням на оборону (1–2 темпи)<br><br>

                <b>СТАНДАРТИ (атака — оборона)</b><br><br>

                <b class="text-[#C59014]">Індивідуальна / групова робота</b><br>
                Оборона — тематичні технічні вправи + флангові завершення
            </div>

            <!-- MD-1 details -->
            <div class="w-[14.28%] border-r-[1px] border-[#C59014] px-[7px] text-[12px] text-center">
                <b>Когнітивні старти, технічний блок, квадрати</b><br><br>

                <b class="text-[#C59014]">— КОМАНДНА ТАКТИКА —</b><br>
                Початок атак (10х0 або чисельна перевага) — вихід від воріт, подолання високого блоку.
                Моделювання пресингу.<br>
                Схеми атаки в середній зоні<br><br>

                <b class="text-[#C59014]">ЗАГРАВАННЯ ФУТБОЛ</b><br>
                в двох зонах<br><br>

                <b>СТАНДАРТИ (атака — оборона)</b>
            </div>

            <!-- Match Day -->
            <div class="w-[14.28%] border-r-[1px] border-[#C59014] px-[7px]"></div>

            <!-- Day-off -->
            <div class="w-[14.28%] px-[7px] text-center font-bold">
                САМОАНАЛІЗ ГРИ
            </div>
        </div>

        <div class="flex justify-center mt-[20px]">
            <div v-if="!openFlag" @click="openFlag = true" class="cursor-pointer">
                <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.75 0.75L6.04289 6.04289C6.37623 6.37623 6.54289 6.54289 6.75 6.54289C6.95711 6.54289 7.12377 6.37623 7.45711 6.04289L12.75 0.75" stroke="#C59014" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div v-else @click="openFlag = false" class="cursor-pointer">
                <svg style="transform: rotate(180deg);" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.75 0.75L6.04289 6.04289C6.37623 6.37623 6.54289 6.54289 6.75 6.54289C6.95711 6.54289 7.12377 6.37623 7.45711 6.04289L12.75 0.75" stroke="#C59014" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue'

export default {
    name: 'week-trainer-cycle-u19',

    setup() {
        const openFlag = ref(false)
        const days = ['НД', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ']

        const today = new Date()
        const dayOfWeek = today.getDay()
        const shortDay = days[dayOfWeek]

        return {
            openFlag,
            shortDay
        }
    }
}
</script>

<style lang="scss">
.current-day-flag {
  box-shadow:
    inset 0 -20px 10px -10px rgba(197, 144, 20, 0.35);
}
</style>
